import dayjs from 'dayjs'

/**
 * Sets the time to the start of a typical business day (09:00).
 * Audits usually begin at the start of business hours to ensure full coverage
 * of the day's activities from the very beginning of the work day.
 */
export const getAuditStartTime = (date: dayjs.ConfigType = dayjs()): Date => {
  return dayjs(date).hour(9).minute(0).second(0).millisecond(0).toDate()
}

/**
 * Sets the time to the end of a typical business day (17:00).
 * Audits usually end at the close of business hours (5 PM) to capture all
 * events occurring within standard working time for that day.
 */
export const getAuditEndTime = (date: dayjs.ConfigType = dayjs()): Date => {
  return dayjs(date).hour(17).minute(0).second(0).millisecond(0).toDate()
}

export const getEndDate = (): Date => {
  return getAuditEndTime(dayjs().add(6, 'month'))
}

export const getStartDate = (): Date => {
  return getAuditStartTime(dayjs().subtract(90, 'day'))
}
